import PositionManagement from './position_management.vue';

export default PositionManagement;
